/* eslint-disable */
import angular from 'angular'
import {
  StateRequest,
  PublishActionTime,
} from '../publishActions/publishActions.dataTypes'
import timePickerTemplate from './template.html'
import intl from 'react-intl-universal'
import moment from 'moment-timezone'

// eslint-disable-next-line @typescript-eslint/no-use-before-define
export default [directive]

function directive() {
  return {
    restrict: 'E',
    scope: {
      //
      humanize: '@',

      // Empty calendar control label
      label: '@',

      // moment.tz instance of current date and time. Timezone should match with
      // defaultTimezone value. If `time` timezone does not match `defaultTimezone`, time
      // will be converted into `defaultTimezone` time zone
      // Updates propagated through `update` callback.
      // Date and time are displayed in a `defaultTimezone` timezone.
      time: '=',

      // Date time limit. Can be `past` or `future` or empty
      // If set to `past`, dates behind current date are not accessible
      limitDate: '<',

      // If renders to `false`, show only date picker control, otherwise date and time
      enableTime: '<',

      // If `false`, hide `Today` button
      enableToday: '<',

      // If `true`, do not show date clear (x) button
      disableClear: '=',

      // If `true`, include quick date picker (yesterday, today, now, tomorrow)
      quickDatePick: '=',

      // make `disabled` attribute works as expected
      pickerDisabled: '=disabled',

      // used to make render the inline picker
      quickPickInline: '@',
      // datetimes used with quickPickInline
      quickPickInlineTimes: '<',

      // DateTime update callback. Date instance is a moment.tz instance with defaultTimezone
      // Callback should convert date to local or UTC timezone if needed
      update: '&',

      // StateRequest, used to request the component to another state
      stateRequest: '<',

      // Default time zone value. Should match with `time` timezone.
      // Usefull when `time` value is empty to construct new moment.tz instance
      // When updated, might swith `today` date to the next day because of timezone difference
      // If differ with `time` timezone, warning will be issued and `time` timezone will be converted
      // to the default timezone.
      defaultTimezone: '<',

      // Custom text to display current timezone in a dropdown
      // Use [0] to substitute timezone name
      // No text if empty
      timezoneText: '@',
    },
    controllerAs: 'vm',
    bindToController: true,
    template: timePickerTemplate,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    controller: ['$scope', TimePickerController],
  }
}

function TimePickerController($scope) {
  $scope.displayTime = ''

  const lang = window.navigator.language
  const timeZone = window.org_settings.timezone

  this.intl = intl

  const dateTimeFormatWithTime = (date) => {
    return new Intl.DateTimeFormat(lang, {
      hour: 'numeric',
      minute: 'numeric',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      timeZone,
    }).format(date)
  }

  const dateTimeFormatWithoutTime = (date) => {
    return new Intl.DateTimeFormat(lang, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'long',
      timeZone,
    }).format(date)
  }

  // TODO: move quicklinks to a seperate directive
  const getQuickLinks = () => {
    let dateQuickLinks = [
      {
        label: intl.get('calendarControl.dateQuickLinks.yesterday'),
        tag: 'yesterday',
      },
      {
        label: intl.get('calendarControl.dateQuickLinks.today'),
        tag: 'today',
      },
      {
        label: intl.get('calendarControl.dateQuickLinks.now'),
        tag: 'now',
      },
      {
        label: intl.get('calendarControl.dateQuickLinks.tomorrow'),
        tag: 'tomorrow',
      },
    ]
    return dateQuickLinks
  }

  const updateTimezoneLabel = () => {
    if (this.time && !this.defaultTimezone) {
      this.defaultTimezone = this.time.tz()
    }
    this.viewTimezoneTextLabel = (this.timezoneText || '').replace(
      '[0]',
      this.defaultTimezone
    )
  }

  const checkDateLimits = () => {
    if (!this.dateTime || !this.limitDate) {
      return
    }
    const now = new Date(
      this.now.year(),
      this.now.month(),
      this.now.date(),
      this.now.hour(),
      this.now.minute()
    )

    // If time is disabled, reset hour and minute to midnight
    if (!this.enableTime) {
      now.setHours(0)
      now.setMinutes(0)
    }

    const limitPast = this.limitDate === 'past'
    if (
      (limitPast && this.dateTime < now) ||
      (!limitPast && this.dateTime > now)
    ) {
      this.dateTime = now
    }
  }

  // Check that `time` instante is moment.tz, refresh `now` and `todayDate` for
  // date calendar.
  const checkUpdateTimeModel = () => {
    if (this.time && typeof this.time.tz !== 'function') {
      if (typeof this.time === 'string' && this.defaultTimezone) {
        this.time = moment.tz(this.time, this.defaultTimezone)
      } else if (this.time instanceof PublishActionTime) {
        this.time = this.time
      } else {
        throw new Error(`Supplied time is not a moment-timezone instance`)
      }
    }

    // If default time zone is not set, infer it from time timezone
    if (this.time && !this.defaultTimezone) {
      this.defaultTimezone = this.time.tz() || 'Etc/UTC'
    }

    // If supplied time in a different timezone, let's say, UTC, convert it back
    // to default timezone.
    if (
      this.time &&
      this.defaultTimezone &&
      this.time.tz() !== this.defaultTimezone
    ) {
      this.time = this.time.tz(this.defaultTimezone)
    }

    if (this.time) {
      const dateFormat = new Date(this.time)
      this.displayTime = new Intl.DateTimeFormat(lang, {
        hour: 'numeric',
        minute: 'numeric',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
      }).format(dateFormat)
    }
    this.now = moment.tz(this.defaultTimezone)
    this.todayDate = dateTimeFormatWithoutTime(moment.tz(this.defaultTimezone))

    if (!this.time) {
      // Flip-flop null/undefined to rerender datepicker and apply possible timezone and
      // date limit changes
      this.dateTime = this.dateTime === null ? undefined : null
    } else {
      // native JS date is used. Note that this date is always in local timezone, so
      // care should be taken
      this.dateTime = new Date(
        this.time.year(),
        this.time.month(),
        this.time.date(),
        this.time.hour(),
        this.time.minute()
      )
    }

    // Update `time` limits if tz has been updated
    checkDateLimits()
    // Update quicklinks if tz has changed
    this.dateQuickLinks = getQuickLinks()
  }

  const changeHandlers = {
    timezoneText: () => {
      updateTimezoneLabel()
    },
    defaultTimezone: () => {
      checkUpdateTimeModel()
      updateTimezoneLabel()
    },
    time: () => {
      checkUpdateTimeModel()
      updateTimezoneLabel()
    },
  }

  // Return a difference between JS date and `todayDate`, which depends on `defaultTimezone`
  const getDiffWithToday = (date) => {
    const d = date.getDate()
    const m = date.getMonth()
    const y = date.getFullYear()
    const newDate = new Date(y, m, d)
    const momentDate = moment
      .tz(newDate.toString(), this.defaultTimezone)
      .hour(0)
      .millisecond(0)
    const momDiff = moment
      .tz(this.defaultTimezone)
      .hour(0)
      .minutes(0)
      .seconds(0)
      .millisecond(0)
      .subtract(1, 'day')
    return momentDate.diff(momDiff)
  }

  // angular-ui date picker day class callback
  // override default implementation relied on local timezone
  const getDayClass = ({ date }) => {
    const diff = getDiffWithToday(date)
    if (diff === 0) {
      return 'uib-day--current'
    }
    if (!this.limitDate || this.limitDate === 'past') {
      return diff > 0 ? 'uib-day--normal' : 'uib-day--past'
    } else {
      return diff < 0 ? 'uib-day--normal' : 'uib-day--past'
    }
  }

  // angular-ui date picker `disabled` callback
  const getDateDisabled = ({ date }) => {
    if (!this.limitDate) {
      return false
    }
    const diff = getDiffWithToday(date)
    return (this.limitDate === 'past') === diff < 0
  }

  // Convert model JS Date (in local timezone) to proper moment.tz date
  const getModelTime = () => {
    if (this.dateTime.constructor === {}.constructor) {
      this.dateTime = this.dateTime['time']
    }
    if (this.dateTime.constructor === moment.utc().constructor) {
      this.dateTime = this.dateTime.toDate()
    }
    // EL-1234
    const tzFormatted = moment(this.dateTime).tz(this.defaultTimezone, true)
    // const newDate = dateTimeFormatWithTime(tzFormatted)
    return tzFormatted
  }

  this.datePickerOptions = {
    showWeeks: false,
    maxMode: 'day',
    customClass: getDayClass,
    dateDisabled: getDateDisabled,
  }

  this.quickPickUpdate = ($event, quickTime) => {
    if (quickTime instanceof PublishActionTime) {
      quickTime = quickTime.asMoment.toDate()
    }
    this.dateTime = quickTime
    this.update({ time: getModelTime() })
  }
  // Enforce date limits if `limitDate` set
  $scope.$watch('vm.dateTime', () => checkDateLimits())

  $scope.$watch('vm.time', () => {
    if (typeof this.time === 'object') {
      if (this.time) {
        this.displayTime = dateTimeFormatWithTime(this.time)
        const formattedTz = moment(this.time).utc().format('Y-MM-DDTHH:mm:ssZ')
        this.time = formattedTz
      } else {
        this.displayTime = null
      }
    }
  })

  this.$onInit = () => {
    this.showMeridian = window.org_settings.clockFormat === '12'

    if (!this.time && !this.defaultTimezone) {
      this.defaultTimezone = window.org_settings.timezone
      // throw new Error(`Unable to infer defaultTimezone. You should set either time or defaultTimezone or both`)
    }
    // Enable time by default
    if (this.enableTime !== false) {
      this.enableTime = true
    }
    checkUpdateTimeModel()
    updateTimezoneLabel()
  }

  this.toggleClose = () => {
    if (this.isOpen === true) {
      this.toggleDropdown({
        preventDefault: function () {},
        stopPropagation: function () {},
      })
    }
  }

  this.toggleDropdown = ($event) => {
    $event.preventDefault()
    $event.stopPropagation()
    this.isOpen = !this.isOpen
  }

  this.clearTime = () => {
    this.update({ time: null })
  }

  this.cancel = ($event) => {
    checkUpdateTimeModel()
    this.toggleDropdown($event)
  }

  this.updateTime = ($event) => {
    this.update({ time: getModelTime() })
    this.toggleDropdown($event)
  }

  this.quickDateUpdate = ($event) => {
    const time = $event.target.dataset.tag
    let set = null
    if (time === 'yesterday') {
      set = moment.tz(this.defaultTimezone).subtract(1, 'days')
    }
    if (time === 'today') {
      set = moment.tz(this.defaultTimezone).hour(0).minutes(0)
    }
    if (time === 'now') {
      this.displayTime = dateTimeFormatWithTime(moment.tz(this.defaultTimezone))
      this.update({ time: moment() })
      return
    }
    if (time === 'tomorrow') {
      set = moment.tz(this.defaultTimezone).add(1, 'days')
    }
    if (set === null) {
      console.info('quickdate is broken')
      return
    }
    this.displayTime = dateTimeFormatWithTime(set)
    this.update({ time: set })
  }

  this.today = ($event) => {
    this.update({ time: this.todayDate })
    this.toggleDropdown($event)
  }

  // toggleClose
  this.$onChanges = (changes) => {
    if (
      angular.isDefined(changes.stateRequest) &&
      angular.isDefined(changes.stateRequest.currentValue) &&
      changes.stateRequest.currentValue !== null
    ) {
      if (
        changes.stateRequest.currentValue.constructor ===
        new StateRequest('noop').constructor
      ) {
        if (changes.stateRequest.currentValue.state === 'close') {
          this.toggleClose()
        }
      } else {
        console.error('Datatype Unhandled')
      }
    }
    Object.keys(changes)
      .filter((key) => changeHandlers.hasOwnProperty(key))
      .forEach((key) => changeHandlers[key](changes[key]))
  }
}
